import { Box, Spinner, StatusIndicator } from '@cloudscape-design/components';
import { AudioMessage, LoadingMessage } from '../../common/types';

export type RenderedAudioMessageProps = {
  message: AudioMessage;
};

export default function RenderedAudioMessage(props: RenderedAudioMessageProps) {
  const loadingMessage = props.message;

  return (
    <Box variant="p">
      <Spinner size="normal" /> Loading...
    </Box>
  );
}
